import React from 'react';
import { ResultsDisplay } from '../components/ResultsDisplay';

export function ResultsPage() {
  return (
    <div>
      <h1>Reparations Voting Results</h1>
      <ResultsDisplay />
    </div>
  );
}
